module.exports = __webpack_public_path__ + "static/media/Illus-SideProtein@3x.442f9c7d.png";